// Who a lead's matched customer is, read before dialing (GTM 2026-10-30).
//
// Server field `customer_match` (crm_backend leads_app/services/customer_match.py):
//   { kind: 'active'|'former'|'prospect'|'contact', label, context, converted }
// e.g. "Returning prospect" · "Quoted Jul 21 · Lawn & Perimeter Bi-Monthly $180 · unsigned"
// (t3 lead 1436). Null when nothing matched, absent on an older server → renders nothing.
import React from 'react';
import Badge from '../ui/badge';
import './CustomerMatchBadge.css';

const TONE = { active: 'success', prospect: 'warning', former: 'neutral', contact: 'neutral' };

export const readCustomerMatch = (lead) => {
  const m = lead?.customer_match;
  return m && typeof m === 'object' && m.label ? m : null;
};

export default function CustomerMatchBadge({ lead, match, compact = false, className = '' }) {
  const m = match || readCustomerMatch(lead);
  if (!m) return null;
  return (
    <div
      className={`lead-match${compact ? ' lead-match--compact' : ''} ${className}`.trim()}
      aria-label={`${m.label}. ${m.context || ''}`}
    >
      <Badge tone={TONE[m.kind] || 'neutral'}>{m.label}</Badge>
      {m.context ? (
        <span className="lead-match__context" title={compact ? m.context : undefined}>
          {m.context}
        </span>
      ) : null}
    </div>
  );
}
